import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    CustomInput,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { useSelector } from 'react-redux';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { putAPI_GuestMessagingReservation_Update, gAPI_GuestMessagingReservation_ById, API_RMS, patch_GUestMessagingReservation_RMS_notes, getAPI_GM_CommunicationChannel_All, getAPI_GM_Settiings_List, API_OracleOpera_Integration, } from '../../../../../../constants/APIs';
import moment from 'moment';
import EmailLogo from '../../../../../../assets/email_icon.png';
import WhatsApp_Logo from '../../../../../../assets/whatsapp_icon.svg';
import SMS_Logo from '../../../../../../assets/sms.svg';
import PhoneLogo from '../../../../../../assets/phone_icon.png';
import SendMessagePanel from '../components/SendMessagingManually/SendMessagePanel'
import countryCodes from '../../../../../../data/dial_code';
import {
    PreCheckinRequestData,
} from '../../../integration/data/OracleOperaFeatures';

const formatDate = (date) => (date ? moment(date).format('YYYY-MM-DD') : null);
const parseDate = (value) => {
    if (!value) return null;
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};
const capitalizeWords = (str) => {
    if (!str) return '';
    return str
        .toString()
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

const validate = (...values) => values.find((v) => v !== undefined && v !== null && v !== '');

const RESERVATION_STATUS = [
    { label: 'Arrived', value: 'Arrived' },
    { label: 'Departed', value: 'Departed' },
    { label: 'Confirmed', value: 'Confirmed' },
    { label: 'Cancelled', value: 'Cancelled' },
]

export default function UpdateReservation({ row = {}, onSuccess, renderTrigger }) {
    const [isOpen, setIsOpen] = useState(false);
    const [arrivalDate, setArrivalDate] = useState(null);
    const [departureDate, setDepartureDate] = useState(null);
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [countryCode, setCountryCode] = useState('+64');
    const [rawPhone, setRawPhone] = useState('');
    const [numAdults, setNumAdults] = useState('');
    const [numChildren, setNumChildren] = useState('');
    const [roomNumber, setRoomNumber] = useState('');
    const [roomTypeName, setRoomTypeName] = useState('');
    const [createdBy, setCreatedBy] = useState('');
    const [loading, setLoading] = useState(false);

    const [isSaving, setIsSaving] = useState(false);
    const [fetchedReservation, setFetchedReservation] = useState(null);
    const [isFetching, setIsFetching] = useState(false);
    const [reference, setReference] = useState('')
    const [bookingSource, setBookingSource] = useState('')
    const [reservationStatusPms, setReservationStatusPms] = useState('')
    const [error, setError] = useState({
        firstName: "",
        lastName: "",
        email: "",
        arrivalDate: "",
        departureDate: ""
    })

    const [isSendPanelOpen, setIsSendPanelOpen] = useState(false);
    const [activeSendTab, setActiveSendTab] = useState(null);

    const [selectedWhatsAppIntegrationId, setSelectedWhatsAppIntegrationId] = useState(null);
    const [selectedEmailIntegrationId, setSelectedEmailIntegrationId] = useState(null);
    const [selectedSMSIntegrationId, setSelectedSMSIntegrationId] = useState(null);
    const [selectedPhoneSuiteIntegrationId, setSelectedPhoneSuiteIntegrationId] = useState(null);
    const [integrationSettings, setIntegrationSettings] = useState(null);
    const settingsFetchedRef = useRef(false);

    const [alertData, setAlertData] = useState([]);
    const [departmentData, setDepartmentData] = useState([]);


    const [pmsReservationId, setPmsReservationId] = useState('');

    const [housekeepingInstructions, setHousekeepingInstructions] = useState('');
    const [turndownRequested, setTurndownRequested] = useState(false);

    const [isSavingHousekeepingNote, setIsSavingHousekeepingNote] = useState(false);
    const [isFetchingHousekeeping, setIsFetchingHousekeeping] = useState(false);
    const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
    const [selectedFeature, setSelectedFeature] = useState('');
    // Pre Check-In Alert States
    const [selectedAlertCode, setSelectedAlertCode] = useState('');
    const [alertArea, setAlertArea] = useState('Reservation'); // Default as per API example
    const [alertDescription, setAlertDescription] = useState('');
    const [screenNotification, setScreenNotification] = useState(true);
    const [printerNotification, setPrinterNotification] = useState(false);
    const [isFetchingAlert, setIsFetchingAlert] = useState(false);
    const [isSavingAlert, setIsSavingAlert] = useState(false);

    // Pre Check-In Trace States
    const [traces, setTraces] = useState([]);
    const [isFetchingTrace, setIsFetchingTrace] = useState(false);
    const [isSavingTrace, setIsSavingTrace] = useState(false);
    const [deleteAlertModal, setDeleteAlertModal] = useState(false);
    const [selectedDeleteAlert, setSelectedDeleteAlert] = useState(null);
    const [isDeletingAlert, setIsDeletingAlert] = useState(false);
    // Pre Check-In Alert States - Multiple Support
    const [alerts, setAlerts] = useState([]); // array of alert objects
    const [traceWarning, setTraceWarning] = useState('');
    const [hotelNotes, setHotelNotes] = useState([]);
    const [fetchedHotelId, setFetchedHotelId] = useState('');
    const [isFetchingHotelNotes, setIsFetchingHotelNotes] = useState(false);
    // pre_check_in_note states
    const [reservationComments, setReservationComments] = useState([]);
    const [isFetchingComments, setIsFetchingComments] = useState(false);
    const [isSavingComment, setIsSavingComment] = useState(false);
    const [selectedHotelNoteId, setSelectedHotelNoteId] = useState(null);
    const [showHotelNoteSection, setShowHotelNoteSection] = useState(true);
    const [showCreateHotelNoteForm, setShowCreateHotelNoteForm] = useState(false);

    // new hotel note creation form fields (also fixes existing handleSaveNewNote bug)
    const [newNoteTitle, setNewNoteTitle] = useState('');
    const [newNoteType, setNewNoteType] = useState('RESERVATION');
    const [newNoteValue, setNewNoteValue] = useState('');
    const [newTypeDescription, setNewTypeDescription] = useState('');
    const [isSavingNewNote, setIsSavingNewNote] = useState(false);
    const [commentError, setCommentError] = useState('');
    const [rmsIntegrationSettings, setRmsIntegrationSettings] = useState(null);
    const [isRmsNoteModalOpen, setIsRmsNoteModalOpen] = useState(false);
    const [rmsNote, setRmsNote] = useState('');
    const [isSavingRmsNote, setIsSavingRmsNote] = useState(false);
    const [isFetchingRmsNote, setIsFetchingRmsNote] = useState(false);


    const openSendPanel = (tab) => {
        setActiveSendTab(tab);
        setIsSendPanelOpen(true);
    };

    const { propertyId, groupId: storedGroupId, userName, timeZone } = useSelector(({ settings }) => ({
        propertyId: settings.propertyId,
        groupId: settings.groupId,
        userName: settings.userName,
        timeZone: settings.timeZone,
    }));

    const formatHeaderDateTime = (value, timeZone) => {
        if (!value) return '';
        return moment.utc(value).tz(timeZone).format('MMM DD, YYYY hh:mm a');
    };

    const groupId = useMemo(() => storedGroupId || getGroupID(), [storedGroupId]);

    const source = fetchedReservation || row.raw || row;

    const lastModified = useMemo(() => {
        return fetchedReservation?.lastModifiedUtc || source?.lastModifiedUtc || null;
    }, [fetchedReservation, source]);


    const reservationStatus = useMemo(() => {
        const status = validate(source.Status, source.status, row.status, '');
        return status ? capitalizeWords(status) : 'Update Reservation';
    }, [source, row]);


    const loadSelectedChannels = useCallback(async () => {
        if (!propertyId) return;

        try {
            const res = await AxiosAPI({
                method: 'get',
                url: getAPI_GM_CommunicationChannel_All,
            });

            const all = res.data || [];
            const propertyChannels = all.filter(
                (item) => item.propertyId === propertyId
            );

            const wa = propertyChannels.find((i) =>
                String(i.channel || '').toLowerCase().includes('what')
            );
            const email = propertyChannels.find((i) =>
                String(i.channel || '').toLowerCase().includes('email')
            );
            const sms = propertyChannels.find((i) =>
                String(i.channel || '').toLowerCase().includes('sms')
            );
            const AiVoice = propertyChannels.find((i) =>
                String(i.channel || '').toLowerCase().includes('phonesuite')
            );

            setSelectedWhatsAppIntegrationId(wa?.integrationId || null);
            setSelectedEmailIntegrationId(email?.integrationId || null);
            setSelectedSMSIntegrationId(sms?.integrationId || null);
            setSelectedPhoneSuiteIntegrationId(AiVoice?.integrationId || null);

        } catch (e) {
            console.error('Failed to load communication channels', e);
        }
    }, [propertyId]);

    const channelsLoadedRef = React.useRef(false);

    const hasWhatsApp = !!selectedWhatsAppIntegrationId
    const hasEmail = !!selectedEmailIntegrationId
    const hasSMS = !!selectedSMSIntegrationId
    const hasAiVoice = !!selectedPhoneSuiteIntegrationId


    useEffect(() => {
        if (!isOpen || !propertyId || settingsFetchedRef.current) return;

        settingsFetchedRef.current = true;
        setLoading(true);

        AxiosAPI({
            method: 'get',
            url: `${getAPI_GM_Settiings_List}/${propertyId}`,
            params: {
                group_id: getGroupID(),
                timeZone: timeZone,
            },
        })
            .then((res) => {
                const payload =
                    res?.data?.result ??
                    res?.data?.data?.result ??
                    res?.data?.data ??
                    res?.data ??
                    null;
                const pms = payload?.pms;
                const pmsIntegrationId = payload?.pmsIntegrationId;
                if (pmsIntegrationId && pms === 'OracleOpera') {
                    AxiosAPI({
                        method: 'get',
                        url: `${API_OracleOpera_Integration}/${pmsIntegrationId}?group_id=${getGroupID()}`,
                    }).then((res) => {
                        setIntegrationSettings(res.data);
                    });
                    AxiosAPI({
                        method: 'get',
                        url: `${API_OracleOpera_Integration}/${pmsIntegrationId}/alert-department-codes?group_id=${getGroupID()}`,
                    }).then((alertRes) => {
                        setAlertData(alertRes.data?.alertList || []);
                        setDepartmentData(alertRes.data?.departmentList || []);
                    }).catch(() => { });
                }
                if (pmsIntegrationId && pms === 'RMS') {
                    AxiosAPI({
                        method: 'get',
                        url: `${API_RMS}/${pmsIntegrationId}?group_id=${getGroupID()}`,
                    }).then((res) => {
                        setRmsIntegrationSettings(res.data);
                    });
                }
            })
            .catch((err) => {
                console.error('Error fetching reservation settings:', err);
                settingsFetchedRef.current = false;
            })
            .finally(() => setLoading(false));
    }, [isOpen, propertyId]);

    useEffect(() => {
        if (!isOpen) {
            setFetchedReservation(null);
            setIsNotesModalOpen(false);
            setHousekeepingInstructions('');
            setTurndownRequested(false);
            setSelectedFeature('');
            setReservationComments([]);
            setSelectedHotelNoteId(null);
            setShowHotelNoteSection(true);
            setShowCreateHotelNoteForm(false);
            setNewNoteTitle('');
            setNewNoteType('RESERVATION');
            setNewNoteValue('');
            setNewTypeDescription('');
            setRmsNote('');
            setIsRmsNoteModalOpen(false);
            return;
        }

        const fetchReservationData = async () => {
            if (!row.id) return;

            setIsFetching(true);
            try {
                const response = await AxiosAPI({
                    method: 'get',
                    url: `${gAPI_GuestMessagingReservation_ById}/${row.id}`,
                });

                setFetchedReservation(response.data);
                setPmsReservationId(response.data?.pmsReservationId || '');
            } catch (err) {
                NotificationManager.error('Failed to fetch reservation data', 'Error', 3000);
                console.error('Error fetching reservation:', err);
            } finally {
                setIsFetching(false);
            }
        };
        fetchReservationData();
        if (channelsLoadedRef.current) return;
        channelsLoadedRef.current = true;
        loadSelectedChannels();

    }, [isOpen, row.id,]);

    useEffect(() => {
        if (!isOpen || !source) return;

        setArrivalDate(parseDate(validate(source.ArrivalDate, source.arrivalDate)));
        setDepartureDate(parseDate(validate(source.DepartureDate, source.departureDate)));
        setFirstName(validate(source.NameFirst, source.nameFirst, row.displayName?.split(' ')[0], ''));
        setMiddleName(validate(source.NameMiddle, source.nameMiddle, ''));
        setLastName(validate(source.NameLast, source.nameLast, ''));
        setEmail(validate(source.EmailAddress, source.emailAddress, row.email));
        let pPhone = validate(source.PhoneMobile, source.phoneMobile, row.phone);
        if (pPhone) {
            let dialCode = '+64';
            let raw = pPhone;
            countryCodes.forEach((m) => {
                if (raw.startsWith(m.dial_code)) {
                    raw = raw.replace(m.dial_code, '');
                    dialCode = m.dial_code;
                }
            });
            setCountryCode(dialCode);
            setRawPhone(raw);
            setPhone(pPhone);
        } else {
            setPhone('');
            setRawPhone('');
        }

        const adultsValue = validate(source.NumberOfAdults, source.numberOfAdults, row.adults);
        const childrenValue = validate(source.NumberOfChildren, source.numberOfChildren, row.childrens);
        setNumAdults(adultsValue === undefined ? '' : String(adultsValue));
        setNumChildren(childrenValue === undefined ? '' : String(childrenValue));

        setRoomNumber(validate(source.RoomNumber, source.roomNumber, ''));
        setRoomTypeName(validate(source.RoomTypeName, source.roomTypeName, ''));
        setReference(validate(source.Reference, source.reference, ''))
        setBookingSource(validate(source.BookingSourceName, source.bookingSourceName))
        setReservationStatusPms(validate(source.reservationStatusPms, source.ReservationStatusPms))
        setCreatedBy(validate(source.CreatedBy, source.createdBy, ''));
    }, [isOpen, source, row]);

    const toggle = useCallback(() => setIsOpen((prev) => !prev), []);

    const triggerNode = useMemo(() => {
        if (typeof renderTrigger === 'function') {
            return renderTrigger({ onClick: toggle, isOpen });
        }
        return (
            <Button color="primary" size="xs" outline className="px-3" onClick={toggle}>
                Edit
            </Button>
        );
    }, [renderTrigger, toggle, isOpen]);

    const availableFeatures = useMemo(() => {
        const features = integrationSettings?.channelDetails?.features || [];

        const preCheckinFeatures = PreCheckinRequestData
            .filter((item) => features.includes(item.value))
            .map((item) => ({
                ...item,
                displayLabel: `${item.label}`,
            }));

        return [...preCheckinFeatures];
    }, [integrationSettings]);

    const handleSaveRmsNote = async () => {
        const iid = rmsIntegrationSettings?.id;

        if (!iid || !pmsReservationId) {
            NotificationManager.error('Reservation information missing', 'Error', 3000);
            return;
        }

        if (!rmsNote.trim()) {
            NotificationManager.error('Note is required', 'Error', 3000);
            return;
        }

        setIsSavingRmsNote(true);
        try {
            await AxiosAPI({
                method: 'patch',
                url: `${API_RMS}/${iid}/reservations/${pmsReservationId}/reservation-note?groupId=${groupId}`,
                data: {
                    note: rmsNote,
                },
            });
            NotificationManager.success('Note saved successfully', 'Success', 3000);
            setIsRmsNoteModalOpen(false);
            setRmsNote('');
        } catch (error) {
            NotificationManager.error('Failed to save note', 'Error', 3000);
        } finally {
            setIsSavingRmsNote(false);
        }
    };
    const fetchRmsNote = async () => {
        const iid = rmsIntegrationSettings?.id;

        if (!iid || !pmsReservationId) return;

        setIsFetchingRmsNote(true);

        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${API_RMS}/${iid}/reservations/${pmsReservationId}/reservation-note?groupId=${groupId}`,
            });

            setRmsNote(res?.data?.note || '');
        } catch (error) {
            console.error('Failed to fetch RMS note', error);
            setRmsNote('');
        } finally {
            setIsFetchingRmsNote(false);
        }
    };

    const fetchHotelNotes = useCallback(async () => {
        const iid = integrationSettings?.id;
        if (!iid) return;
        setIsFetchingHotelNotes(true);
        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${API_OracleOpera_Integration}/${iid}/hotel-notes?groupid=${groupId}`,
            });
            const notes = res.data?.hotelConfigInfo?.hotelNotes || [];
            setHotelNotes(notes);
            setFetchedHotelId(res.data?.hotelConfigInfo?.hotelId || '');
            return notes;
        } catch (e) {
            console.error('Failed to fetch hotel notes', e);
            NotificationManager.error('Failed to fetch hotel notes', 'Error', 3000);
        } finally {
            setIsFetchingHotelNotes(false);
        }

    }, [integrationSettings, groupId]);

    const handleSaveNewNote = async (commentIndex) => {
        const iid = integrationSettings?.id;
        if (!iid) return;
        if (!newNoteTitle.trim() || !newNoteType.trim() || !newNoteValue.trim()) {
            NotificationManager.error('All fields are required', 'Error', 3000);
            return;
        }
        const savedTitle = newNoteTitle;
        const savedType = newNoteType;
        setIsSavingNewNote(true);
        try {
            await AxiosAPI({
                method: 'post',
                url: `${API_OracleOpera_Integration}/${iid}/hotel-notes?groupid=${groupId}`,
                data: {
                    hotelNotes: [{
                        comment: {
                            commentTitle: newNoteTitle,
                            type: newNoteType,
                            typeDescription: newTypeDescription,
                            internal: false,
                            hotelId: fetchedHotelId,
                            text: { value: newNoteValue },
                        }
                    }]
                }
            });
            NotificationManager.success('Hotel note added successfully', 'Success', 3000);
            setNewNoteTitle('');
            setNewNoteType('RESERVATION');
            setNewNoteValue('');
            setNewTypeDescription('');

            const refreshedNotes = await fetchHotelNotes();
            if (refreshedNotes) {
                const newNote = refreshedNotes.find(
                    n => n.comment?.commentTitle === savedTitle && n.comment?.type === savedType
                );
                if (newNote) {
                    setReservationComments(prev => {
                        const updated = [...prev];
                        updated[commentIndex] = {
                            ...updated[commentIndex],
                            linkedHotelNoteId: newNote.id,
                            commentTitle: newNote.comment?.commentTitle || '',
                            type: newNote.comment?.type || '',
                            internal: newNote.comment?.internal ?? true,
                            text: newNote.comment?.text?.value || '',
                            showCreateForm: false,
                            isDirty: updated[commentIndex].isExisting,
                        };
                        return updated;
                    });
                }
            }
        } catch (e) {
            NotificationManager.error('Failed to add hotel note', 'Error', 3000);
        } finally {
            setIsSavingNewNote(false);
        }
    };


    // Fetch existing housekeeping note
    const fetchHousekeepingNote = async () => {
        const iid = integrationSettings?.id;
        if (!iid || !pmsReservationId) return;

        setIsFetchingHousekeeping(true);
        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${API_OracleOpera_Integration}/${iid}/reservations/${pmsReservationId}/housekeeping-note?groupid=${groupId}`,
            });

            const data = res.data || {};

            setHousekeepingInstructions(data.instructions || '');
            setTurndownRequested(!!data.turndownRequested);

        } catch (error) {
            console.error('Failed to fetch housekeeping note', error);
            // If no note exists, the form will remain empty
            setHousekeepingInstructions('');
            setTurndownRequested(false);
        } finally {
            setIsFetchingHousekeeping(false);
        }
    };

    const handleSaveHousekeepingNote = async () => {
        const iid = integrationSettings?.id;

        if (!iid || !pmsReservationId) {
            NotificationManager.error(
                'Reservation information missing',
                'Error',
                3000
            );
            return;
        }

        if (!housekeepingInstructions.trim()) {
            NotificationManager.error(
                'Instructions are required',
                'Error',
                3000
            );
            return;
        }

        setIsSavingHousekeepingNote(true);

        try {
            await AxiosAPI({
                method: 'put',
                url: `${API_OracleOpera_Integration}/${iid}/reservations/${pmsReservationId}/housekeeping-note?groupid=${groupId}`,
                data: {
                    instructions: housekeepingInstructions,
                    turndownRequested,
                },
            });

            NotificationManager.success(
                'Housekeeping note added successfully',
                'Success',
                3000
            );
            fetchHousekeepingNote()
        } catch (error) {
            NotificationManager.error(
                'Failed to add housekeeping note',
                'Error',
                3000
            );
        } finally {
            setIsSavingHousekeepingNote(false);
        }
    };
    // Fetch existing Pre Check-In Alert
    // Fetch existing alerts
    const fetchExistingAlert = async () => {
        const iid = integrationSettings?.id;
        if (!iid || !pmsReservationId) return;

        setIsFetchingAlert(true);
        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${API_OracleOpera_Integration}/${iid}/alerts/${pmsReservationId}?groupId=${groupId}`,
            });

            const data = res.data || {};
            let existingAlerts = [];

            if (data.reservations?.reservation?.[0]?.alerts) {
                existingAlerts = data.reservations.reservation[0].alerts;
            } else if (Array.isArray(data.alerts)) {
                existingAlerts = data.alerts;
            } else if (Array.isArray(data)) {
                existingAlerts = data;
            }

            const mappedAlerts = existingAlerts.map(alert => ({
                id: alert.id,
                code: alert.code || '',
                area: alert.area || 'Reservation',
                description: alert.description || '',
                screenNotification: !!alert.screenNotification,
                printerNotification: !!alert.printerNotification,
                global: !!alert.global,
                isExisting: true,
                isDirty: false,          // ← not dirty until user touches it
            }));

            setAlerts(mappedAlerts.length > 0 ? mappedAlerts : [getEmptyAlert()]);
        } catch (error) {
            console.error('Failed to fetch alerts', error);
            setAlerts([getEmptyAlert()]);
        } finally {
            setIsFetchingAlert(false);
        }
    };

    const getEmptyAlert = () => ({
        id: null,
        code: '',
        area: 'Reservation',
        description: '',
        screenNotification: true,
        printerNotification: false,
        isExisting: false,
        isDirty: false,
    });

    const addNewAlert = () => {
        setAlerts(prev => [...prev, getEmptyAlert()]);
    };

    const removeAlert = (index) => {
        setAlerts(prev => {
            const updated = prev.filter((_, i) => i !== index);
            return updated.length > 0 ? updated : [getEmptyAlert()];
        });
    };

    const updateAlert = (index, field, value) => {
        setAlerts(prev => {
            const updated = [...prev];
            if (updated[index]?.global) {
                return updated;
            }

            const current = updated[index];
            const dirtyPatch = current.isExisting ? { isDirty: true } : {};
            updated[index] = { ...current, [field]: value, ...dirtyPatch };
            return updated;
        });
    };

    const handleAlertSelect = (index, code) => {
        const selected = alertData.find(a => a.code === code);
        updateAlert(index, 'code', code);
        if (selected) {
            updateAlert(index, 'description', selected.description || selected.name || '');
        }
    };
    const resetAlertForm = () => {
        setSelectedAlertCode('');
        setAlertArea('');
        setAlertDescription('');
        setScreenNotification(true);
        setPrinterNotification(false);
    };


    // Save Pre Check-In Alert
    // Save Pre Check-In Alert (Multiple)
    // Save Pre Check-In Alert - Smart Handling (POST for new + PUT for existing)
    const handleSaveAlert = async () => {
        const iid = integrationSettings?.id;
        if (!iid || !pmsReservationId) {
            NotificationManager.error('Reservation information missing', 'Error', 3000);
            return;
        }

        const validAlerts = alerts.filter(a => a.code?.trim());
        if (validAlerts.length === 0) {
            NotificationManager.error('At least one alert is required', 'Error', 3000);
            return;
        }

        setIsSavingAlert(true);

        try {
            const newAlerts = validAlerts.filter(a => !a.isExisting);
            const existingAlerts = validAlerts.filter(a => a.isExisting && a.id && a.isDirty); // ← isDirty check

            // Add this guard to prevent unnecessary API calls when there are no valid alerts to save
            if (newAlerts.length === 0 && existingAlerts.length === 0) {
                NotificationManager.info('No changes to save', 'Info', 3000);
                setIsSavingAlert(false);
                return;
            }
            let successCount = 0;

            // 1. POST New Alerts
            if (newAlerts.length > 0) {
                const postPayload = {
                    reservations: [
                        {
                            reservationIdList: [{ type: "Reservation", id: pmsReservationId }],
                            alerts: newAlerts.map(alert => ({
                                code: alert.code,
                                area: alert.area || "Reservation",
                                description: alert.description || "",
                                screenNotification: !!alert.screenNotification,
                                printerNotification: !!alert.printerNotification,
                                type: "Alert"
                            })),
                            hotelId: integrationSettings?.channelDetails.hotelId || '',
                            customReference: "",
                            preRegistered: false,
                            allowMobileCheckout: false
                        }
                    ]
                };

                await AxiosAPI({
                    method: 'post',
                    url: `${API_OracleOpera_Integration}/${iid}/alerts/${pmsReservationId}/?groupId=${groupId}`,
                    data: postPayload,
                });
                successCount++;
            }

            // 2. PUT Update Existing Alerts
            if (existingAlerts.length > 0) {
                const putPayload = {
                    reservations: [
                        {
                            reservationIdList: [{ type: "Reservation", id: pmsReservationId }],
                            alerts: existingAlerts.map(alert => ({
                                code: alert.code,
                                area: alert.area || "Reservation",
                                description: alert.description || "",
                                screenNotification: !!alert.screenNotification,
                                printerNotification: !!alert.printerNotification,
                                id: alert.id,                    // Important for update
                                type: "Alert"
                            })),
                            hotelId: integrationSettings?.channelDetails?.hotelId || '',
                            customReference: "",
                            preRegistered: false,
                            allowMobileCheckout: false
                        }
                    ]
                };

                await AxiosAPI({
                    method: 'put',
                    url: `${API_OracleOpera_Integration}/${iid}/alerts/${pmsReservationId}/update?groupId=${groupId}`,
                    data: putPayload,
                });
                successCount++;
            }

            if (successCount > 0) {
                NotificationManager.success(
                    successCount === 2 ? 'All Alerts updated successfully' :
                        newAlerts.length > 0 ? 'New Alerts added successfully' : 'Alerts updated successfully',
                    'Success',
                    3000
                );
            }

            // Refresh list
            fetchExistingAlert();

        } catch (error) {
            NotificationManager.error('Failed to save alerts', 'Error', 3000);
            console.error(error);
        } finally {
            setIsSavingAlert(false);
        }
    };

    const handleDeleteAlert = async () => {
        const iid = integrationSettings?.id;

        if (!iid || !pmsReservationId || selectedDeleteAlert?.id === null) {
            NotificationManager.error(
                'Unable to delete alert',
                'Error',
                3000
            );
            return;
        }

        setIsDeletingAlert(true);

        try {
            const payload = {
                reservations: [
                    {
                        reservationIdList: [
                            {
                                type: 'Reservation',
                                id: pmsReservationId,
                            },
                        ],
                        alerts: [
                            {
                                id: selectedDeleteAlert?.id,
                            },
                        ],
                        hotelId:
                            integrationSettings?.channelDetails?.hotelId || '',
                    },
                ],
            };

            await AxiosAPI({
                method: 'put',
                url: `${API_OracleOpera_Integration}/${iid}/alerts/${pmsReservationId}/delete?groupId=${groupId}`,
                data: payload,
            });

            NotificationManager.success(
                'Alert deleted successfully',
                'Success',
                3000
            );
            setDeleteAlertModal(false);
            setSelectedDeleteAlert(null);

            fetchExistingAlert();
        } catch (error) {
            console.error(error);

            NotificationManager.error(
                'Failed to delete alert',
                'Error',
                3000
            );
        }
        finally {
            setIsDeletingAlert(false);
        }
    };

    const handleSaveTrace = async () => {
        const iid = integrationSettings?.id;
        if (!iid || !pmsReservationId) {
            NotificationManager.error('Reservation information missing', 'Error', 3000);
            return;
        }

        const validTraces = traces.filter(t => t.departmentId?.trim());
        if (validTraces.length === 0) {
            NotificationManager.error('At least one trace is required', 'Error', 3000);
            return;
        }

        const newTraces = validTraces.filter(t => !t.isExisting);
        const dirtyExistingTraces = validTraces.filter(t => t.isExisting && t.id && t.isDirty);
        const tracesToSave = [...newTraces, ...dirtyExistingTraces];

        if (tracesToSave.length === 0) {
            NotificationManager.info('No changes to save', 'Info', 3000);
            return;
        }

        setIsSavingTrace(true);
        setTraceWarning('');
        try {
            const payload = {
                reservations: [{
                    reservationIdList: [{ type: "Reservation", id: pmsReservationId }],
                    traces: tracesToSave.map(t => ({
                        ...(t.isExisting && t.id ? { id: t.id } : {}),
                        timeInfo: {
                            // dateTimeSpan: {
                            //     startDateTime: t.startDateTime
                            //         ? moment(t.startDateTime).format('YYYY-MM-DD HH:mm:ss.S')
                            //         : null,
                            //     endDateTime: t.endDateTime
                            //         ? moment(t.endDateTime).format('YYYY-MM-DD HH:mm:ss.S')
                            //         : null,
                            // },
                            traceOn: t.traceOn
                                ? moment(t.traceOn).format('YYYY-MM-DD HH:mm:ss.S')
                                : null,
                            traceTime: t.traceTime || '',
                        },
                        departmentId: t.departmentId,
                        traceText: t.traceText,
                    })),
                    hotelId: integrationSettings?.channelDetails?.hotelId || '',
                    customReference: "",
                    preRegistered: false,
                    allowMobileCheckout: false
                }]
            };

            const response = await AxiosAPI({
                method: 'post',
                url: `${API_OracleOpera_Integration}/${iid}/traces/${pmsReservationId}/?groupId=${groupId}`,
                data: payload,
            });
            const warnings = response?.data?.warnings || [];

            if (warnings.length > 0) {
                const warningMessages = warnings.map(w => w.shortText || w.text || 'Unknown error');

                setTraces(prev => {
                    const updated = [...prev];

                    // Clear all previous errors first
                    updated.forEach(trace => trace.error = '');

                    // Assign warnings to the traces that were actually sent (new + dirty)
                    // We match by order in which they were sent in payload
                    let warningIdx = 0;
                    for (let i = 0; i < updated.length && warningIdx < warningMessages.length; i++) {
                        const isSentInThisSave = !updated[i].isExisting || updated[i].isDirty;
                        if (isSentInThisSave) {
                            updated[i].error = warningMessages[warningIdx];
                            warningIdx++;
                        }
                    }
                    return updated;
                });

                return;
            }
            NotificationManager.success('Traces saved successfully', 'Success', 3000);
            fetchExistingTrace();
        } catch (error) {
            NotificationManager.error('Failed to save traces', 'Error', 3000);
            console.error(error);
        } finally {
            setIsSavingTrace(false);
        }
    };
    const getEmptyTrace = () => ({
        id: null,
        departmentId: '',
        traceText: '',
        traceOn: null,
        traceTime: '',
        isExisting: false,
        isDirty: false,
        error: '',
    });

    const fetchExistingTrace = async () => {
        const iid = integrationSettings?.id;
        if (!iid || !pmsReservationId) return;

        setIsFetchingTrace(true);
        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${API_OracleOpera_Integration}/${iid}/traces/${pmsReservationId}?groupId=${groupId}`,
            });

            const data = res.data || {};
            let existingTraces = [];

            if (data.reservations?.reservation?.[0]?.traces) {
                existingTraces = data.reservations.reservation[0].traces;
            } else if (Array.isArray(data.traces)) {
                existingTraces = data.traces;
            }

            const mappedTraces = existingTraces.map(trace => ({
                id: trace.id,
                departmentId: trace.departmentId || '',
                traceText: trace.traceText || '',
                traceOn: trace.timeInfo?.traceOn ? new Date(trace.timeInfo.traceOn) : null,
                traceTime: trace.timeInfo?.traceTime || '',
                isExisting: true,
                isDirty: false,
                error: '',
            }));

            setTraces(mappedTraces.length > 0 ? mappedTraces : [getEmptyTrace()]);
        } catch (error) {
            console.error('Failed to fetch traces', error);
            setTraces([getEmptyTrace()]);
        } finally {
            setIsFetchingTrace(false);
        }
    };

    const addNewTrace = () => {
        setTraces(prev => [...prev, getEmptyTrace()]);
    };

    const removeTrace = (index) => {
        setTraces(prev => {
            const updated = prev.filter((_, i) => i !== index);
            return updated.length > 0 ? updated : [getEmptyTrace()];
        });
    };

    const updateTrace = (index, field, value) => {
        setTraceWarning('');
        setTraces(prev => {
            const updated = [...prev];
            const current = updated[index];
            const dirtyPatch = current.isExisting ? { isDirty: true } : {};
            updated[index] = { ...current, [field]: value, ...dirtyPatch, error: '' };
            return updated;
        });
    };

    const handleDepartmentSelect = (index, code) => {
        const selected = departmentData.find(d => d.code === code);
        updateTrace(index, 'departmentId', code);
        if (selected) {
            updateTrace(index, 'traceText', selected.description || selected.name || '');
        }
    };

    // ─── Pre Check-In Note helpers ───────────────────────────────────────────────

    const getEmptyComment = () => ({
        id: null,
        commentTitle: '',
        type: 'RESERVATION', // default to reservation-level note
        internal: true,
        text: '',
        isExisting: false,
        error: '',
        isDirty: false,
        linkedHotelNoteId: null,   // ← which hotel note selected for THIS comment
        showHotelSection: true,    // ← always true for new comments
        showCreateForm: false,
    });

    const fetchReservationComments = async (notes) => {
        const resolvedNotes = notes ?? hotelNotes;
        const iid = integrationSettings?.id;
        if (!iid || !pmsReservationId) return;

        setIsFetchingComments(true);
        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${API_OracleOpera_Integration}/${iid}/reservations/${pmsReservationId}/comments?groupId=${groupId}`,
            });

            const data = res.data;
            let existingComments = [];

            if (Array.isArray(data)) {
                existingComments = data;
            } else if (data?.reservations?.reservation?.[0]?.comments) {
                existingComments = data.reservations.reservation[0].comments;
            } else if (Array.isArray(data?.comments)) {
                existingComments = data.comments;
            }


            const mapped = existingComments.map(c => {
                const matchedNote = resolvedNotes.find(n =>
                    c.comment?.commentTitle === n.comment?.commentTitle &&
                    c.comment?.type === n.comment?.type
                );
                return {
                    id: c.id,
                    commentTitle: c.comment?.commentTitle || '',
                    type: c.comment?.type || '',
                    internal: !!c.comment?.internal,
                    text: c.comment?.text?.value || '',
                    isExisting: true,
                    isDirty: false,
                    linkedHotelNoteId: matchedNote?.id || null,
                    showHotelSection: !!matchedNote,
                    showCreateForm: false,
                };
            });


            setReservationComments(mapped.length > 0 ? mapped : [getEmptyComment()]);
        } catch (err) {
            console.error('Failed to fetch comments', err);
            setReservationComments([getEmptyComment()]);
            setShowHotelNoteSection(true);
        } finally {
            setIsFetchingComments(false);
        }
    };

    const handleHotelNoteSelect = (index, noteId) => {
        setCommentError(prev => ({
            ...prev,
            [index]: ''
        }));
        setReservationComments(prev => {
            const updated = [...prev];
            const note = hotelNotes.find(n => n.id === noteId);
            updated[index] = {
                ...updated[index],
                linkedHotelNoteId: noteId || null,
                ...(note ? {
                    commentTitle: note.comment?.commentTitle || '',
                    type: note.comment?.type || '',
                    internal: note.comment?.internal ?? true,
                    text: note.comment?.text?.value || '',
                } : {}),
                isDirty: updated[index].isExisting,
            };
            return updated;
        });
    };
    const UI_ONLY_FIELDS = ['showCreateForm', 'showHotelSection', 'linkedHotelNoteId'];

    const updateComment = (index, field, value) => {
        setCommentError(prev => ({
            ...prev,
            [index]: ''
        }));
        setReservationComments(prev => {
            const updated = [...prev];
            const current = updated[index];
            const dirtyPatch = (current.isExisting && !UI_ONLY_FIELDS.includes(field))
                ? { isDirty: true }
                : {};
            updated[index] = { ...current, [field]: value, ...dirtyPatch };
            return updated;
        });
    };

    const addNewComment = () => {
        setReservationComments(prev => [...prev, getEmptyComment()]);
    };

    const removeComment = (index) => {
        setReservationComments(prev => {
            const updated = prev.filter((_, i) => i !== index);
            return updated.length > 0 ? updated : [getEmptyComment()];
        });
    };

    const handleSaveComments = async () => {
        setCommentError({});
        const iid = integrationSettings?.id;
        if (!iid || !pmsReservationId) {
            NotificationManager.error('Reservation information missing', 'Error', 3000);
            return;
        }

        const validComments = reservationComments.filter(c => c.commentTitle?.trim());
        if (validComments.length === 0) {
            NotificationManager.error('At least one comment title is required', 'Error', 3000);
            return;
        }

        const newComments = validComments.filter(c => !c.isExisting);
        const dirtyExisting = validComments.filter(c => c.isExisting && c.id && c.isDirty);

        if (newComments.length === 0 && dirtyExisting.length === 0) {
            NotificationManager.info('No changes to save', 'Info', 3000);
            return;
        }

        setIsSavingComment(true);
        try {
            // POST new comments
            if (newComments.length > 0) {
                const response = await AxiosAPI({
                    method: 'post',
                    url: `${API_OracleOpera_Integration}/${iid}/reservations/${pmsReservationId}/comments?groupId=${groupId}`,
                    data: {
                        reservations: [{
                            comments: newComments.map(c => ({
                                comment: {
                                    commentTitle: c.commentTitle,
                                    notificationLocation: 'RESERVATION',
                                    type: c.type || '',
                                    internal: !!c.internal,
                                    text: { value: c.text },
                                }
                            }))
                        }]
                    },
                });
                if (response?.data?.type === 'Bad Request') {
                    const errorMsg = response?.data?.title || response?.data?.detail || 'Bad Request';
                    // Find first new comment index
                    const errorIndex = reservationComments.findIndex(c => !c.isExisting);
                    if (errorIndex !== -1) {
                        setCommentError(prev => ({ ...prev, [errorIndex]: errorMsg }));
                    }
                    return;
                }

            }

            // PUT each dirty existing comment (API URL includes commentId)
            for (let i = 0; i < dirtyExisting.length; i++) {
                const c = dirtyExisting[i];
                const originalIndex = reservationComments.findIndex(comment =>
                    comment.id === c.id && comment.isExisting
                );

                const response = await AxiosAPI({
                    method: 'put',
                    url: `${API_OracleOpera_Integration}/${iid}/reservations/${pmsReservationId}/comments/${c.id}?groupId=${groupId}`,
                    data: {
                        reservations: [{
                            comments: [{
                                comment: {
                                    commentTitle: c.commentTitle,
                                    notificationLocation: 'RESERVATION',
                                    type: c.type || '',
                                    internal: !!c.internal,
                                    text: { value: c.text },
                                },
                                id: c.id,
                                type: 'Comment',
                            }]
                        }]
                    },
                });

                if (response?.data?.type === 'Bad Request') {
                    const errorMsg = response?.data?.title || response?.data?.detail || 'Bad Request';
                    if (originalIndex !== -1) {
                        setCommentError(prev => ({
                            ...prev,
                            [originalIndex]: errorMsg
                        }));
                    }
                    return; // Stop on first error (or remove if you want to continue)
                }

            }


            NotificationManager.success('Comments saved successfully', 'Success', 3000);
            fetchReservationComments();
        } catch (err) {
            NotificationManager.error('Failed to save comments', 'Error', 3000);
            console.error(err);
        } finally {
            setIsSavingComment(false);
        }
    };

    const openNotesModal = (feature) => {
        setSelectedFeature(feature);
        setIsNotesModalOpen(true);

        if (feature === 'house_keeping_note') {
            fetchHousekeepingNote();
        } else if (feature === 'pre_check_in_alert') {
            fetchExistingAlert();
        }
        else if (feature === 'pre_check_in_trace') {
            fetchExistingTrace();
        }
        else if (feature === 'pre_check_in_note') {
            setIsFetchingComments(true);
            setIsNotesModalOpen(true);
            fetchHotelNotes().then((notes) => {
                fetchReservationComments(notes);
            });
        }

    };

    const closeNotesModal = () => {
        setCommentError({});
        setIsNotesModalOpen(false);
        setSelectedFeature('');
    };
    const handleUpdate = async () => {
        let newErrors = {};
        if (!firstName?.trim()) newErrors.firstName = "First name is mandatory";
        if (!lastName?.trim()) newErrors.lastName = "Last name is mandatory";
        if (!email?.trim()) newErrors.email = "Email is mandatory";

        if (!arrivalDate) newErrors.arrivalDate = "Arrival date is mandatory";
        if (!departureDate) newErrors.departureDate = "Departure date is mandatory";

        // Departure must be greater than arrival
        if (arrivalDate && departureDate) {
            if (moment(departureDate).isBefore(arrivalDate)) {
                newErrors.departureDate = "Departure date cannot be before arrival date";
            }
        }
        setError(newErrors);

        if (Object.keys(newErrors).length > 0) {
            return;
        }
        if (!propertyId || !groupId) {
            NotificationManager.error('Select a property to continue', 'Error', 3000);
            return;
        }
        const payload = {
            ...(fetchedReservation || source),
            ReservationId: fetchedReservation?.id || source.id,
            ArrivalDate: formatDate(arrivalDate) || fetchedReservation?.ArrivalDate || source.ArrivalDate || null,
            DepartureDate: formatDate(departureDate) || fetchedReservation?.DepartureDate || source.DepartureDate || null,
            ArrivalEstimatedTime:
                arrivalDate ? moment(arrivalDate).format('HH:mm') : fetchedReservation?.ArrivalEstimatedTime || source.ArrivalEstimatedTime || '',
            DepartureEstimatedTime:
                departureDate ? moment(departureDate).format('HH:mm') : fetchedReservation?.DepartureEstimatedTime || source.DepartureEstimatedTime || '',
            NumberOfAdults: Number(numAdults) || 0,
            NumberOfChildren: Number(numChildren) || 0,
            RoomNumber: roomNumber || fetchedReservation?.RoomNumber || source.RoomNumber || '',
            RoomTypeName: roomTypeName || fetchedReservation?.RoomTypeName || source.RoomTypeName || '',
            Reference: reference || fetchedReservation?.Reference || source.Reference || '',
            BookingSourceName: bookingSource || fetchedReservation?.BookingSourceName || source.BookingSourceName || '',
            ReservationStatusPms: reservationStatusPms || fetchedReservation?.reservationStatusPms || source.ReservationStatusPms || '',
            NameFirst: firstName || fetchedReservation?.NameFirst || source.NameFirst || '',
            NameMiddle: middleName || fetchedReservation?.NameMiddle || source.NameMiddle || '',
            NameLast: lastName || fetchedReservation?.NameLast || source.NameLast || '',
            PhoneMobile: phone || fetchedReservation?.PhoneMobile || source.PhoneMobile || '',
            EmailAddress: email || fetchedReservation?.EmailAddress || source.EmailAddress || '',
            UpdatedBy: fetchedReservation?.UpdatedBy || source.UpdatedBy || userName || 'system',
        };

        setIsSaving(true);
        try {
            await AxiosAPI({
                method: 'put',
                url: putAPI_GuestMessagingReservation_Update,
                data: payload,
            });
            NotificationManager.success('Reservation updated successfully', 'Success', 3000);
            toggle();
            if (onSuccess) onSuccess();
        } catch (err) {
            NotificationManager.error('Failed to update reservation', 'Error', 3000);
        } finally {
            setIsSaving(false);
        }
    };


    const numberOptions = (min, max) => {
        const option = [<option key="default" value="">Select</option>];
        for (let i = min; i <= max; i += 1) {
            option.push(
                <option key={i} value={Number(i)}>
                    {i}
                </option>
            );
        }
        return option;
    };
    const reservationId = fetchedReservation?.id
    return (
        <>
            {triggerNode}
            <Modal
                isOpen={isOpen}
                toggle={toggle}
                wrapClassName={`modal-right update-reservation-modal ${isSendPanelOpen ? 'with-send-panel' : ''}`}
                backdrop="static"
            >
                <ModalHeader toggle={toggle} style={{ padding: "22px" }}>
                    <span style={{ fontSize: "1rem" }}><b>{reservationStatus}</b></span>
                    {lastModified && (
                        <span style={{ fontSize: "0.9rem" }}><b>
                            {' '}({formatHeaderDateTime(lastModified, timeZone)})</b>
                        </span>
                    )}
                </ModalHeader>
                <ModalBody>
                    {isFetching ? (

                        <div className="loading" />
                    ) : (
                        <Row>
                            <Colxx sm={12}>
                                <h6 className="mt-1 mb-2">
                                    <b>Reservation Details</b>
                                </h6>
                            </Colxx>
                            <Colxx sm={6}>
                                <Label className="mt-2">Arrival Date <span style={{ color: "red" }}>*</span></Label>
                                <DatePicker
                                    selected={arrivalDate}
                                    onChange={(d) => {
                                        setArrivalDate(d);
                                        if (error.arrivalDate) setError({ ...error, arrivalDate: "" });
                                    }}
                                    placeholderText="arrival date"
                                    dateFormat="dd/MM/yyyy"
                                />
                                {error.arrivalDate && (
                                    <span style={{ color: "red", fontSize: "12px" }}>{error.arrivalDate}</span>
                                )}
                            </Colxx>

                            <Colxx sm={6}>
                                <Label className="mt-2">Departure Date <span style={{ color: "red" }}>*</span></Label>
                                <DatePicker
                                    selected={departureDate}
                                    onChange={(d) => {
                                        setDepartureDate(d);
                                        if (error.departureDate) setError({ ...error, departureDate: "" });
                                    }}
                                    placeholderText="departure date"
                                    dateFormat="dd/MM/yyyy"
                                />
                                {error.departureDate && (
                                    <span style={{ color: "red", fontSize: "12px" }}>{error.departureDate}</span>
                                )}
                            </Colxx>

                            <Colxx sm={6}>
                                <Label className="mt-2">Number of adults</Label>
                                <Input
                                    type="select"
                                    value={numAdults}
                                    onChange={(e) => setNumAdults(e.target.value)}
                                >
                                    {numberOptions(1, 6)}
                                </Input>
                            </Colxx>
                            <Colxx sm={6}>
                                <Label className="mt-2">Number of children</Label>
                                <Input
                                    type="select"
                                    value={numChildren}
                                    onChange={(e) => setNumChildren(e.target.value)}
                                >
                                    {numberOptions(0, 6)}
                                </Input>
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Room type</Label>
                                <Input
                                    type="text"
                                    value={roomTypeName}
                                    onChange={(e) => setRoomTypeName(e.target.value)}
                                    placeholder="Room type"
                                />
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Room number</Label>
                                <Input
                                    type="text"
                                    value={roomNumber}
                                    onChange={(e) => setRoomNumber(e.target.value)}
                                    placeholder="Room number"
                                />
                            </Colxx>

                            <Colxx sm={12}>
                                <Label className="mt-2">Reference Number</Label>
                                <Input
                                    type="text"
                                    value={reference}
                                    onChange={(e) => setReference(e.target.value)}
                                    placeholder="Reference number"
                                />
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Booking Source Name</Label>
                                <Input
                                    type="text"
                                    value={bookingSource}
                                    onChange={(e) => setBookingSource(e.target.value)}
                                    placeholder="Booking Source"
                                />
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Reservation Status</Label>
                                <Input
                                    type="select"
                                    value={reservationStatusPms}
                                    onChange={(e) => setReservationStatusPms(e.target.value)}
                                >
                                    <option value="">Select Status</option>
                                    {RESERVATION_STATUS.map(status => (
                                        <option key={status.value} value={status.value}>
                                            {status.label}
                                        </option>
                                    ))}
                                </Input>

                            </Colxx>

                            <Colxx sm={12} className="mt-3">
                                <h6 className="mb-2">
                                    <b>Guest Details</b>
                                </h6>
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">First Name <span style={{ color: "red" }}>*</span></Label>
                                <Input className='input_sty' type="text" value={firstName}
                                    onChange={(e) => {
                                        setFirstName(e.target.value);
                                        if (error.firstName) setError({ ...error, firstName: "" });
                                    }}
                                    placeholder="First name"
                                />
                                {error.firstName && (
                                    <span style={{ color: "red", fontSize: "12px" }}>{error.firstName}</span>
                                )}
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Middle Name (Optional)</Label>
                                <Input
                                    type="text"
                                    value={middleName}
                                    onChange={(e) => setMiddleName(e.target.value)}
                                    placeholder="Middle name"
                                />
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Last Name <span style={{ color: "red" }}>*</span></Label>
                                <Input
                                    type="text"
                                    value={lastName}
                                    onChange={(e) => {
                                        setLastName(e.target.value);
                                        if (error.lastName) setError({ ...error, lastName: "" });
                                    }}
                                    placeholder="Last name"
                                />
                                {error.lastName && (
                                    <span style={{ color: "red", fontSize: "12px" }}>{error.lastName}</span>
                                )}
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Email Address <span style={{ color: "red" }}>*</span></Label>
                                <InputGroup>
                                    <Input
                                        type="email"
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                            if (error.email) setError({ ...error, email: "" });
                                        }}
                                        placeholder="Email"
                                    />

                                    {hasEmail && (
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText
                                                style={{ cursor: 'pointer' }}
                                                title="Send Email"
                                                onClick={() => {
                                                    openSendPanel('email')
                                                }}
                                            >
                                                <img src={EmailLogo} alt="Email" style={{ width: '1.2rem' }} />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    )}
                                </InputGroup>
                                {error.email && (
                                    <span style={{ color: "red", fontSize: "12px" }}>{error.email}</span>
                                )}

                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Phone Number</Label>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <Input
                                            type="select"
                                            name="countryCode"
                                            value={countryCode}
                                            onChange={(e) => {
                                                const newCode = e.target.value;
                                                setCountryCode(newCode);
                                                setPhone(`${newCode}${rawPhone}`);
                                            }}
                                            style={{
                                                width: '85px',
                                                textAlign: 'center',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {countryCodes.map((c) => (
                                                <option key={c.code} value={c.dial_code}>
                                                    {c.code} {c.dial_code} ({c.name})
                                                </option>
                                            ))}
                                        </Input>
                                    </InputGroupAddon>
                                    <Input
                                        type="text"
                                        value={rawPhone}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setRawPhone(val);
                                            setPhone(`${countryCode}${val}`);
                                        }}
                                        placeholder="Phone"
                                    />

                                    {hasWhatsApp && (
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText
                                                style={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                title="Send WhatsApp"
                                                onClick={() => {
                                                    openSendPanel('whatsapp');
                                                }}
                                            >
                                                <img src={WhatsApp_Logo} alt="WhatsApp" style={{ width: '1.2rem' }} />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    )}

                                    {hasSMS && (
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText
                                                style={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                title="Send SMS"
                                                onClick={() => {
                                                    openSendPanel('sms');
                                                }}
                                            >
                                                <img src={SMS_Logo} alt="Sms" style={{ width: '0.8rem' }} />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    )}
                                    {hasAiVoice && (
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText
                                                style={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                title="Send AI Voice Message"
                                                onClick={() => {
                                                    openSendPanel('aivoice');
                                                }}
                                            >
                                                <img src={PhoneLogo} alt="AI Voice" style={{ width: '1rem' }} />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    )}
                                </InputGroup>
                            </Colxx>
                            {createdBy === 'OracleJob' && integrationSettings && Object.keys(integrationSettings).length > 0 && (
                                <Colxx sm={12} className="mt-3 mb-3">
                                    <h6 className="mb-2"><b>Oracle Features</b></h6>

                                    {availableFeatures.length === 0 ? (
                                        <div style={{
                                            fontSize: 13, color: '#8a94a6', padding: '10px 14px',
                                            border: '1px dashed #d3d8e0', borderRadius: 8, background: '#fafdff',
                                        }}>
                                            ⚠️ No features are enabled. Please add Pre Check-In features in the Oracle Opera Integration settings first.
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                            {availableFeatures.map((feature) => {
                                                let buttonText = '';
                                                switch (feature.value) {
                                                    case 'house_keeping_note':
                                                        buttonText = 'Housekeeping Note';

                                                        break;
                                                    case 'pre_check_in_alert':
                                                        buttonText = 'Pre Check-In Alert';

                                                        break;
                                                    case 'pre_check_in_trace':
                                                        buttonText = 'Pre Check-In Trace';

                                                        break;
                                                    case 'pre_check_in_note':
                                                        buttonText = 'Pre Check-In Note';

                                                        break;
                                                    default:
                                                        buttonText = feature.displayLabel || feature.label;
                                                }

                                                return (
                                                    <Button
                                                        key={feature.value}
                                                        color="primary"
                                                        size="sm"
                                                        onClick={() => openNotesModal(feature.value)}
                                                    >
                                                        {buttonText}
                                                    </Button>
                                                );
                                            })}
                                        </div>
                                    )}
                                </Colxx>
                            )}
                            {/* ── RMS Features ── */}
                            {createdBy === 'RmsJob' && rmsIntegrationSettings && Object.keys(rmsIntegrationSettings).length > 0 && (
                                <Colxx sm={12} className="mt-3 mb-3">
                                    <h6 className="mb-2"><b>Additional Info</b></h6>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                        <Button
                                            color="secondary"
                                            size="xs"
                                            outline
                                            onClick={async () => {
                                                setIsRmsNoteModalOpen(true);
                                                await fetchRmsNote();
                                            }}
                                        >
                                            View & Update Notes
                                        </Button>
                                    </div>
                                </Colxx>
                            )}
                        </Row>
                    )}
                </ModalBody>


                <ModalFooter>
                    <Button color="primary" size="xs" onClick={handleUpdate} disabled={isSaving}>
                        Update
                    </Button>
                    <Button color="secondary" size="xs" outline onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
                {/* ==================== NEW NOTES MODAL ==================== */}
                {/* ==================== NOTES / FEATURES POPUP MODAL ==================== */}
                {/* ==================== DYNAMIC NOTES / FEATURES MODAL ==================== */}
                <Modal
                    isOpen={isNotesModalOpen}
                    toggle={closeNotesModal}
                    backdrop="static"
                    size="lg"
                >
                    <ModalHeader toggle={closeNotesModal}>
                        {selectedFeature === 'house_keeping_note' && 'Housekeeping Note'}
                        {selectedFeature === 'pre_check_in_alert' && 'Pre Check-In Alert'}
                        {selectedFeature === 'pre_check_in_trace' && 'Pre Check-In Trace'}
                        {selectedFeature === 'pre_check_in_note' && 'Pre Check-In Note'}
                        {!selectedFeature && 'Oracle Feature'}
                    </ModalHeader>
                    <ModalBody>
                        {selectedFeature === 'house_keeping_note' ? (
                            isFetchingHousekeeping ? (
                                <div className="loading" />
                            ) : (
                                <div className="p-3">
                                    <Label className="mt-2">
                                        Instructions <span style={{ color: 'red' }}>*</span>
                                    </Label>
                                    <Input
                                        type="textarea"
                                        rows={5}
                                        value={housekeepingInstructions}
                                        onChange={(e) => setHousekeepingInstructions(e.target.value)}
                                        placeholder="Enter detailed housekeeping instructions..."
                                    />


                                    <div className="mt-3">
                                        <CustomInput
                                            type="checkbox"
                                            id="turndownRequested"
                                            label="Turndown Requested"
                                            defaultChecked={turndownRequested}
                                            onChange={(e) => setTurndownRequested(e.target.checked)}
                                        />
                                    </div>
                                </div>
                            )
                        ) : selectedFeature === 'pre_check_in_alert' ? (
                            isFetchingAlert ? (
                                <div className="loading" />
                            ) : (
                                <div>
                                    {alerts.map((alert, index) => {
                                        const usedCodes = alerts
                                            .map((a, i) => (i !== index ? a.code : null))
                                            .filter(Boolean);

                                        const availableAlerts = alertData.filter(a => !usedCodes.includes(a.code));

                                        return (
                                            <div key={`alert-${index}`} className="border p-3 mb-4 rounded" style={{ background: '#f8f9fa' }}>
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h6>Alert {index + 1}</h6>
                                                    {alerts.length > 0 && !alert.global && (

                                                        <Button
                                                            color="danger"
                                                            size="sm"
                                                            onClick={() => {
                                                                if (alert.isExisting && alert.id) {
                                                                    setSelectedDeleteAlert(alert);
                                                                    setDeleteAlertModal(true);
                                                                } else {
                                                                    removeAlert(index);
                                                                }
                                                            }}
                                                        >
                                                            Remove
                                                        </Button>
                                                    )}
                                                </div>

                                                <Label>Select Alert</Label>
                                                <Input
                                                    type="select"
                                                    value={alert.code}
                                                    onChange={(e) => handleAlertSelect(index, e.target.value)}
                                                    disabled={alert.global}
                                                >
                                                    <option value="">-- Select Alert --</option>
                                                    {availableAlerts.map((a) => (
                                                        <option key={a.code} value={a.code}>
                                                            {a.code} - {a.description || a.name}
                                                        </option>
                                                    ))}
                                                </Input>

                                                <Label className="mt-3">Code <span style={{ color: 'red' }}>*</span></Label>
                                                <Input type="text" value={alert.code} readOnly />

                                                <Label className="mt-3">Area <span style={{ color: 'red' }}>*</span></Label>
                                                <Input
                                                    type="text"
                                                    value={alert.area}
                                                    onChange={(e) => updateAlert(index, 'area', e.target.value)}
                                                    readOnly
                                                />

                                                <Label className="mt-3">Description</Label>
                                                <Input
                                                    type="textarea"
                                                    rows={3}
                                                    value={alert.description}
                                                    onChange={(e) => updateAlert(index, 'description', e.target.value)}
                                                    disabled={alert.global}
                                                />

                                                <div className="mt-3">
                                                    <CustomInput
                                                        type="checkbox"
                                                        id={`screen-${index}`}
                                                        label="Screen Notification"
                                                        defaultChecked={alert.screenNotification}
                                                        disabled={alert.global}
                                                        onChange={(e) => updateAlert(index, 'screenNotification', e.target.checked)}
                                                    />
                                                </div>
                                                <div className="mt-2">
                                                    <CustomInput
                                                        type="checkbox"
                                                        id={`printer-${index}`}
                                                        label="Printer Notification"
                                                        defaultChecked={alert.printerNotification}
                                                        disabled={alert.global}
                                                        onChange={(e) => updateAlert(index, 'printerNotification', e.target.checked)}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}

                                    <Button color="success" size="sm" onClick={addNewAlert} className="mt-3">
                                        + Add More Alert
                                    </Button>
                                </div>
                            )
                        )
                            : selectedFeature === 'pre_check_in_trace' ? (
                                isFetchingTrace ? (
                                    <div className="loading" />
                                ) : (
                                    <div>
                                        {traces.map((trace, index) => {
                                            const usedCodes = traces
                                                .map((t, i) => (i !== index ? t.departmentId : null))
                                                .filter(Boolean);

                                            const availableDepartments = departmentData.filter(d => !usedCodes.includes(d.code));

                                            return (
                                                <div key={`trace-${index}`} className="border p-3 mb-4 rounded" style={{ background: '#f8f9fa' }}>
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <h6>Trace {index + 1}</h6>
                                                        {!trace.isExisting && (
                                                            <Button color="danger" size="sm" onClick={() => removeTrace(index)}>
                                                                Remove
                                                            </Button>
                                                        )}
                                                    </div>

                                                    <Label>Select Department</Label>
                                                    <Input
                                                        type="select"
                                                        value={trace.departmentId || ''}
                                                        onChange={(e) => handleDepartmentSelect(index, e.target.value)}
                                                    >
                                                        <option value="">-- Select Department --</option>
                                                        {availableDepartments.map((d) => (
                                                            <option key={d.code} value={d.code}>
                                                                {d.code} - {d.description || d.name}
                                                            </option>
                                                        ))}
                                                    </Input>

                                                    <Label className="mt-3">Department ID <span style={{ color: 'red' }}>*</span></Label>
                                                    <Input type="text" value={trace.departmentId || ''} readOnly />

                                                    <Label className="mt-3">Trace Text</Label>
                                                    <Input
                                                        type="textarea"
                                                        rows={3}
                                                        value={trace.traceText || ''}
                                                        onChange={(e) => updateTrace(index, 'traceText', e.target.value)}
                                                    />

                                                    <Label className="mt-3">Trace On <span style={{ color: 'red' }}>*</span></Label>
                                                    <DatePicker
                                                        selected={trace.traceOn}
                                                        onChange={(date) => {
                                                            updateTrace(index, 'traceOn', date);

                                                            if (date) {
                                                                updateTrace(
                                                                    index,
                                                                    'traceTime',
                                                                    moment(date).format('HH:mm')
                                                                );
                                                            } else {
                                                                updateTrace(index, 'traceTime', '');
                                                            }
                                                        }}
                                                        showTimeSelect
                                                        timeIntervals={15}
                                                        dateFormat="dd/MM/yyyy hh:mm aa"
                                                        className="form-control"
                                                    />
                                                    {trace.error && (
                                                        <div
                                                            style={{
                                                                color: '#dc3545',
                                                                marginTop: '10px',
                                                                fontSize: '14px',
                                                                fontWeight: '500'
                                                            }}
                                                        >
                                                            {trace.error}
                                                        </div>
                                                    )}

                                                    <Label className="mt-3">Trace Time <span style={{ color: 'red' }}>*</span></Label>
                                                    <Input
                                                        type="text"
                                                        value={trace.traceTime || ''}
                                                        onChange={(e) => updateTrace(index, 'traceTime', e.target.value)}
                                                        placeholder="HH:mm"
                                                    />


                                                </div>
                                            );
                                        })}
                                        <Button color="success" size="sm" onClick={addNewTrace} className="mt-4">
                                            + Add More Trace
                                        </Button>
                                    </div>
                                )
                            ) : selectedFeature === 'pre_check_in_note' ? (
                                isFetchingComments ? (
                                    <div className="loading" />
                                ) : (
                                    <div>
                                        {reservationComments.map((comment, index) => (
                                            <div
                                                key={`comment-${index}`}
                                                className="border p-3 mb-4 rounded"
                                                style={{ background: '#f8f9fa' }}
                                            >
                                                {/* ── Card header ── */}
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h6>Comment {index + 1}</h6>
                                                    {reservationComments.length > 1 && !comment.isExisting && (
                                                        <Button color="danger" size="sm" onClick={() => removeComment(index)}>
                                                            Remove
                                                        </Button>
                                                    )}
                                                </div>

                                                {/* ── Hotel Note section (per-comment) ── */}
                                                {comment.showHotelSection && (
                                                    <div className="mb-3 p-3 " style={{ background: '#eef6fb', border: '1px solid #c8e0ef' }}>
                                                        <div className="d-flex align-items-end" style={{ gap: '10px' }}>
                                                            <div style={{ flex: 1 }}>
                                                                <Label>Select Hotel Note</Label>
                                                                <Input
                                                                    type="select"
                                                                    value={comment.linkedHotelNoteId || ''}
                                                                    onChange={(e) => handleHotelNoteSelect(index, e.target.value)}
                                                                >
                                                                    <option value="">-- Select Hotel Note --</option>
                                                                    {hotelNotes.map((n) => (
                                                                        <option key={n.id} value={n.id}>
                                                                            {n.comment?.type} - {n.comment?.commentTitle}
                                                                        </option>
                                                                    ))}
                                                                </Input>
                                                            </div>
                                                            <Button
                                                                color="success"
                                                                size="sm"
                                                                style={{ whiteSpace: 'nowrap', marginBottom: '1px' }}
                                                                onClick={() => updateComment(index, 'showCreateForm', true)}
                                                                disabled={comment.showCreateForm}
                                                            >
                                                                + Create Hotel Note
                                                            </Button>
                                                        </div>

                                                        {/* Create Hotel Note sub-form */}
                                                        {comment.showCreateForm && (
                                                            <div className="border p-3 mt-3 rounded" style={{ background: '#f0fff4' }}>
                                                                <h6 className="mb-3">New Hotel Note</h6>

                                                                <Label>Comment Title <span style={{ color: 'red' }}>*</span></Label>
                                                                <Input
                                                                    type="text"
                                                                    value={newNoteTitle}
                                                                    onChange={(e) => setNewNoteTitle(e.target.value)}
                                                                    placeholder="Comment title"
                                                                />

                                                                <Label className="mt-2">Type <span style={{ color: 'red' }}>*</span></Label>
                                                                <Input
                                                                    type="text"
                                                                    value={newNoteType || 'RESERVATION'}
                                                                    onChange={(e) => setNewNoteType(e.target.value)}
                                                                    placeholder="e.g. RESERVATION"
                                                                    readOnly
                                                                />

                                                                <Label className="mt-2">Type Description</Label>
                                                                <Input
                                                                    type="text"
                                                                    value={newTypeDescription}
                                                                    onChange={(e) => setNewTypeDescription(e.target.value)}
                                                                    placeholder="Type description"
                                                                />

                                                                <Label className="mt-2">Text <span style={{ color: 'red' }}>*</span></Label>
                                                                <Input
                                                                    type="textarea"
                                                                    rows={3}
                                                                    value={newNoteValue}
                                                                    onChange={(e) => setNewNoteValue(e.target.value)}
                                                                    placeholder="Note text"
                                                                />

                                                                <div className="d-flex mt-3" style={{ gap: '8px' }}>
                                                                    <Button
                                                                        color="primary"
                                                                        size="sm"
                                                                        onClick={() => handleSaveNewNote(index)}
                                                                        disabled={isSavingNewNote}
                                                                    >
                                                                        {isSavingNewNote ? 'Saving...' : 'Save'}
                                                                    </Button>
                                                                    <Button
                                                                        color="secondary"
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            updateComment(index, 'showCreateForm', false);
                                                                            setNewNoteTitle('');
                                                                            setNewNoteType('RESERVATION');
                                                                            setNewNoteValue('');
                                                                            setNewTypeDescription('');
                                                                        }}
                                                                    >
                                                                        Cancel
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* ── Comment fields ── */}
                                                <Label>Comment Title <span style={{ color: 'red' }}>*</span></Label>
                                                <Input
                                                    type="text"
                                                    value={comment.commentTitle}
                                                    onChange={(e) => updateComment(index, 'commentTitle', e.target.value)}
                                                    placeholder="Comment title"
                                                />

                                                <Label className="mt-2">Type</Label>
                                                <Input
                                                    type="text"
                                                    value={comment.type}
                                                    onChange={(e) => updateComment(index, 'type', e.target.value)}
                                                    placeholder="e.g. RESERVATION, GUEST_PROFILE"
                                                    readOnly
                                                />
                                                {commentError[index] && (
                                                    <div
                                                        style={{
                                                            color: '#dc3545',
                                                            marginTop: '10px',
                                                            fontSize: '14px',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                        {commentError[index]}
                                                    </div>
                                                )}
                                                <div className="mt-2">
                                                    <CustomInput
                                                        type="checkbox"
                                                        id={`comment-internal-${index}`}
                                                        label="Internal"
                                                        defaultChecked={!!comment.internal}
                                                        onChange={(e) => updateComment(index, 'internal', e.target.checked)}
                                                    />
                                                </div>

                                                <Label className="mt-2">Text <span style={{ color: 'red' }}>*</span></Label>
                                                <Input
                                                    type="textarea"
                                                    rows={3}
                                                    value={comment.text}
                                                    onChange={(e) => updateComment(index, 'text', e.target.value)}
                                                    placeholder="Comment text"
                                                />
                                            </div>
                                        ))}

                                        <Button color="success" size="sm" onClick={addNewComment} className="mt-2">
                                            + Add More Comment
                                        </Button>
                                    </div>
                                )
                            ) : (
                                <div className="p-4 text-center">
                                    <h5>Coming Soon</h5>
                                    <p>{selectedFeature} feature is under development.</p>
                                </div>
                            )}
                    </ModalBody>
                    <ModalFooter>
                        {selectedFeature === 'house_keeping_note' && (
                            <Button
                                color="primary"
                                onClick={handleSaveHousekeepingNote}
                                disabled={isSavingHousekeepingNote || !housekeepingInstructions.trim()}
                            >
                                {isSavingHousekeepingNote ? 'Saving...' : 'Save Housekeeping Note'}
                            </Button>
                        )}
                        {selectedFeature === 'pre_check_in_alert' && (
                            <Button
                                color="primary"
                                onClick={handleSaveAlert}
                                disabled={isSavingAlert || alerts.every(a => !a.code)}
                            >
                                {isSavingAlert ? 'Saving...' : 'Save All Alerts'}
                            </Button>
                        )}
                        {selectedFeature === 'pre_check_in_trace' && (
                            <Button
                                color="primary"
                                onClick={handleSaveTrace}
                                disabled={isSavingTrace || traces.every(t => !t.departmentId)}
                            >
                                {isSavingTrace ? 'Saving...' : 'Save All Traces'}
                            </Button>
                        )}
                        {selectedFeature === 'pre_check_in_note' && (
                            <Button
                                color="primary"
                                onClick={handleSaveComments}
                                disabled={isSavingComment || reservationComments.every(c => !c.commentTitle?.trim())}
                            >
                                {isSavingComment ? 'Saving...' : 'Save All Comments'}
                            </Button>
                        )}
                        <Button color="secondary" onClick={closeNotesModal}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </Modal>
            <Modal
                isOpen={deleteAlertModal}
                toggle={() => setDeleteAlertModal(false)}
                centered
                style={{ boxShadow: 'none' }}

            >
                <ModalHeader toggle={() => setDeleteAlertModal(false)}>
                    Delete Alert
                </ModalHeader>

                <ModalBody>
                    <div className="text-center">
                        <i
                            className="simple-icon-exclamation text-danger"
                            style={{ fontSize: "48px" }}
                        />

                        <h5 className="mt-3">
                            Are you sure?
                        </h5>

                        <p className="text-muted mb-0">
                            This alert will be permanently removed.
                        </p>
                    </div>
                </ModalBody>

                <ModalFooter>
                    <Button
                        color="secondary"
                        outline
                        onClick={() => setDeleteAlertModal(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        color="danger"
                        onClick={handleDeleteAlert}
                        disabled={isDeletingAlert}
                    >
                        {isDeletingAlert ? "Deleting..." : "Delete"}
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={isRmsNoteModalOpen}
                toggle={() => setIsRmsNoteModalOpen(false)}
                backdrop="static"
                size="md"
            >
                <ModalHeader toggle={() => setIsRmsNoteModalOpen(false)}>
                    Reservation Notes
                </ModalHeader>
                <ModalBody>
                    {isFetchingRmsNote ? (
                        <div className="loading" />
                    ) : (
                        <div className="p-3">
                            <Label>
                                Note <span style={{ color: 'red' }}>*</span>
                            </Label>
                            <Input
                                type="textarea"
                                rows={5}
                                value={rmsNote}
                                onChange={(e) => setRmsNote(e.target.value)}
                                placeholder="Enter reservation note..."
                            />
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        size="xs"
                        onClick={handleSaveRmsNote}
                        disabled={isSavingRmsNote || !rmsNote.trim()}
                    >
                        {isSavingRmsNote ? 'Saving...' : 'Save Note'}
                    </Button>
                    <Button color="secondary" size="xs" outline onClick={() => setIsRmsNoteModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            {isSendPanelOpen && (
                <SendMessagePanel
                    activeTab={activeSendTab}
                    onClose={() => setIsSendPanelOpen(false)}
                    preFillPhoneNumber={phone}
                    propertyId={propertyId}
                    showPhoneNumber={true}
                    reservationId={reservationId}
                    source="Manually"

                    reservationData={{
                        firstName,
                        lastName,
                        phone,
                        email,
                        roomNumber,
                        roomTypeName,
                        arrivalDate,
                        departureDate,
                    }}
                />
            )}

        </>
    );

}